import api from "../../BrandOnBoarding/api";
import {
  FETCH_LLM_OPTIONS_REQUEST,
  FETCH_LLM_OPTIONS_SUCCESS,
  FETCH_LLM_OPTIONS_FAILURE,
} from "../constants/actionTypes";

export const fetchLLMOptions = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_LLM_OPTIONS_REQUEST });
  try {
    const response = await api.get(`/users/${userId}/config`);
    const rawOptions = response.data?.LLM_OPTIONS || [];
    const options = [
      ...rawOptions.filter((o) => o.value === "gpt-6-luna"),
      ...rawOptions.filter((o) => o.value !== "gpt-6-luna"),
    ];
    const groupCustomers = response.data?.group_customers || [];
    localStorage.setItem("llm_options", JSON.stringify(options));
    localStorage.setItem("group_customers", JSON.stringify(groupCustomers));
    dispatch({ type: FETCH_LLM_OPTIONS_SUCCESS, payload: { options, groupCustomers } });
  } catch (error) {
    dispatch({ type: FETCH_LLM_OPTIONS_FAILURE, error: error.message });
  }
};
